import { render, staticRenderFns } from "./DeleteArchiveDialogBox.vue?vue&type=template&id=a2b198aa&scoped=true&"
import script from "./DeleteArchiveDialogBox.vue?vue&type=script&lang=js&"
export * from "./DeleteArchiveDialogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b198aa",
  null
  
)

export default component.exports